<template>
  <div class="off-canvas off-canvas-sidebar-show">
    <Sidebar></Sidebar>

    <a v-on:click="closeSidebar" class="off-canvas-overlay"></a>

    <main class="off-canvas-content p-0">
      <span id="updating" class="m-1" v-if="updating">
        <i class="icon loading"></i> Updating...
      </span>
      <router-view />
      <OutputModal />
    </main>
  </div>
</template>

<script>
import { debounce } from "debounce";

import MPCStore from "./stores/MPCStore";
import OptionStore from "./stores/OptionStore";
import ConfigStore from "./stores/ConfigStore";
import PFStore from "./stores/PFStore";
import OPFStore from "./stores/OPFStore";
import Module from "./module";

import Sidebar from "./components/Sidebar";
import OutputModal from "./components/OutputModal";

const App = {
  name: "App",
  beforeCreate() {
    MPCStore.methods.loadMPC();
    OptionStore.methods.loadOptions();
    ConfigStore.methods.loadConfig();
  },
  methods: {
    update: debounce(function() {
      let data = this;
      data.updating = true;
      setTimeout(() => (data.updating = false), 1500);

      PFStore.methods.runPF();
      OPFStore.methods.runOPF();
      MPCStore.methods.saveMPC();
    }, ConfigStore.methods.getDebounce()),

    saveOptions: debounce(OptionStore.methods.saveOptions, 1000),

    onConfigChange: debounce(function() {
      ConfigStore.methods.saveConfig();
      // this.update();
    }, 1000),

    closeSidebar: Sidebar.methods.closeSidebar
  },
  data() {
    return {
      Module: Module.data,
      MPCStore: MPCStore.data,
      PFStore: PFStore.data,
      OPFStore: OPFStore.data,
      OptionStore: OptionStore.data,
      ConfigStore: ConfigStore.data,
      updating: false
    };
  },
  watch: {
    Module: {
      deep: true,
      handler: "update"
    },
    MPCStore: {
      deep: true,
      handler: "update"
    },
    OptionStore: {
      deep: true,
      handler: () => {
        App.methods.saveOptions();
        App.methods.update();
      }
    },
    ConfigStore: {
      deep: true,
      handler: "onConfigChange"
    }
  },
  components: { Sidebar, OutputModal }
};

export default App;
</script>

<style lang="scss">
@import "main.scss";

#updating {
  position: absolute;
  bottom: 0;
}

#subheader {
  border-bottom: 0.05rem solid $gray-color;
}

caption {
  font-weight: 500;
}

#output-modal .modal-container {
  max-width: 800px;
}

tr th,
tr td {
  white-space: nowrap;
}
</style>
